// Tests: src/app/migrations/migrations.spec.ts
import { MigrationDefinition } from './migration.types';

/**
 * Migration: V13 → V14
 *
 * Grubenprotokoll-Wiki: `klimabereich` ist Text **alt+neu**. Bisher wurde
 * das Feld nur als einfacher String gespeichert. Diese Migration hebt es
 * auf `AltNeu<string>` ({ alt?: string, neu?: string }) an.
 *
 * Upgrade: vorhandener String wandert nach `.neu` (Standardannahme: heutiger
 * Eintrag entspricht dem neuen Wertekatalog). Leer/undefined bleibt
 * undefined.
 *
 * Downgrade: bevorzugt `.neu`, fallback `.alt`. Wenn beides leer ist,
 * wird das Feld entfernt.
 */
export const migrationV13ToV14: MigrationDefinition = {
  fromVersion: 13,
  toVersion: 14,

  upgrade(doc: any): any {
    const eh = doc.extendedHeader;
    if (eh && typeof eh.klimabereich === 'string') {
      const s = eh.klimabereich;
      if (s) eh.klimabereich = { neu: s };
      else delete eh.klimabereich;
    }
    doc.version = 14;
    return doc;
  },

  downgrade(doc: any): any {
    const eh = doc.extendedHeader;
    if (eh && eh.klimabereich && typeof eh.klimabereich === 'object') {
      const an = eh.klimabereich;
      const s = an.neu || an.alt || '';
      if (s) eh.klimabereich = s;
      else delete eh.klimabereich;
    }
    doc.version = 13;
    return doc;
  },

  dataLossWarnings: [
    'Beim Downgrade geht der alte Wert von klimabereich verloren, wenn neu+alt beide gesetzt waren (nur einer ueberlebt)'
  ]
};
